import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  isShowHeader: true,
  code: 0,
  current: 0,
  isShowGoBack: false,
}
const mutations = {
  updateisShowHeader(state, newValue) {
    state.isShowHeader = newValue;
  },
  setExamCode(state, newValue) {
    state.code = newValue;
  },
  setCurrent(state, newValue) {
    state.current = newValue;
  },
  setIsShowGoBack(state, newValue) {
    state.isShowGoBack = newValue;
  }
}
const actions = {
  updateisShowHeader(context, newValue) {
    context.commit('updateisShowHeader', newValue);
  }
}
const getters = {
  getisShowHeader: state => {
    return state.isShowHeader;
  }
}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js